import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Courses from "./pages/Courses";
import About from "./pages/About";
import Auth from "./pages/Auth";
import Account from "./pages/Account";
import Checkout from "./pages/Checkout";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import Admin from "./pages/admin/Admin";

function StorefrontLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<StorefrontLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/prodotto/:id" element={<ProductDetail />} />
                <Route path="/corsi" element={<Courses />} />
                <Route path="/chi-siamo" element={<About />} />
                <Route path="/accedi" element={<Auth />} />
                <Route path="/account" element={<Account />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/pagamento/riuscito" element={<PaymentSuccess />} />
                <Route path="/pagamento/annullato" element={<PaymentCancel />} />
              </Route>
              <Route path="/admin/*" element={<Admin />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" toastOptions={{ style: { background: "#1C1713", color: "#FAF7F2", border: "1px solid #3D3128" } }} />
        </CartProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
